/* Shared step-navigation + review-summary engine for the Heirloom and
   Altar consultation wizards. Data submission itself is a plain Shopify
   contact form post — this file only drives the on-page UI. */
(function () {
  var CONFIGS = {
    h: {
      totalSteps: 4,
      summaryBoxId: 'heirloomSummaryBox',
      totalFieldId: 'heirloomEstimatedTotal',
      textFields: [
        { label: 'Name', selector: '[name="contact[Full Name]"]' },
        { label: 'Email', selector: '[name="contact[email]"]' },
        { label: 'Vessel', selector: '[name="contact[Vessel Type]"]' },
        { label: 'In memory of', selector: '[name="contact[In Memory Of]"]' }
      ],
      priceFields: [
        { label: 'Size', name: 'contact[Vessel Size]' },
        { label: 'Scent', name: 'contact[Scent Path]' },
        { label: 'Insurance', name: 'contact[Insurance]' }
      ]
    },
    a: {
      totalSteps: 5,
      summaryBoxId: 'altarSummaryBox',
      totalFieldId: 'altarEstimatedTotal',
      textFields: [
        { label: 'Name', selector: '[name="contact[Full Name]"]' },
        { label: 'Email', selector: '[name="contact[email]"]' },
        { label: 'Event date', selector: '[name="contact[Event Date]"]' },
        { label: 'Venue', selector: '[name="contact[Venue]"]' }
      ],
      priceFields: [
        { label: 'Set size', name: 'contact[Set Size]' },
        { label: 'Delivery', name: 'contact[Delivery Method]' }
      ]
    }
  };

  function row(key, val) {
    return '<div class="summary-row"><span class="key">' + key + '</span><span class="val">' + (val || '—') + '</span></div>';
  }

  function getRadio(name) {
    var el = document.querySelector('input[name="' + name + '"]:checked');
    if (!el) return null;
    return { value: el.value, price: parseFloat(el.getAttribute('data-price') || '0') };
  }

  function buildSummary(prefix) {
    var cfg = CONFIGS[prefix];
    if (!cfg) return;
    var rows = '';
    cfg.textFields.forEach(function (f) {
      var el = document.querySelector(f.selector);
      rows += row(f.label, el ? el.value : '');
    });

    var total = 0;
    var hasZeroSelection = false;
    cfg.priceFields.forEach(function (f) {
      var r = getRadio(f.name);
      rows += row(f.label, r ? r.value : 'Not selected');
      if (r) {
        total += r.price;
      } else {
        hasZeroSelection = true;
      }
    });

    var totalLabel = '$' + total.toFixed(0);
    rows += '<div class="summary-total"><span class="key">Estimated Total</span><span class="val">' + totalLabel + '</span></div>';

    var box = document.getElementById(cfg.summaryBoxId);
    if (box) box.innerHTML = rows;
    var totalField = document.getElementById(cfg.totalFieldId);
    if (totalField) totalField.value = totalLabel;
  }

  function goStep(prefix, n) {
    var cfg = CONFIGS[prefix];
    document.querySelectorAll('.step-panel').forEach(function (p) { p.classList.remove('active'); });
    var panel = document.getElementById(prefix + 'step' + n);
    if (panel) panel.classList.add('active');

    var total = cfg ? cfg.totalSteps : 5;
    for (var i = 1; i <= total; i++) {
      var prog = document.getElementById('prog' + i);
      if (!prog) continue;
      prog.classList.remove('active', 'done');
      if (i < n) prog.classList.add('done');
      if (i === n) prog.classList.add('active');
    }

    if (n === total) buildSummary(prefix);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function applyGiftVisibility(isGift) {
    document.querySelectorAll('[data-gift-visibility]').forEach(function (el) {
      var show = (el.getAttribute('data-gift-visibility') === 'gift') === isGift;
      el.style.display = show ? '' : 'none';
    });
  }

  function initGiftToggle() {
    var radios = document.querySelectorAll('input[name="contact[Is This A Gift]"]');
    if (!radios.length) return;
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        applyGiftVisibility(r.value === 'Yes, this is a gift' && r.checked);
      });
    });
    var checked = document.querySelector('input[name="contact[Is This A Gift]"]:checked');
    applyGiftVisibility(!!checked && checked.value === 'Yes, this is a gift');
  }

  window.larueGoStep = goStep;
  window.larueBuildSummary = buildSummary;
  window.larueInitWizard = function (prefix) {
    goStep(prefix, 1);
    initGiftToggle();
  };
})();
